import { Observable } from 'rxjs';
import {
  TipologiaCantiere,
  CreateTipologiaCantiereDto,
  TipologiaCantierePage,
} from '../../models/tipo-cantiere.model';

export abstract class TipoCantierePort {
  abstract getList(params?: { size?: number; offset?: number; tipoSearch?: string }): Observable<TipologiaCantierePage>;
  abstract create(dto: CreateTipologiaCantiereDto): Observable<number>;
}
